export const routes = {
    root: "/",
    pages: {
        games: "/games",
        hot: "/games/hot",
        new: "/games/new",
        game: "/game",
        offers: "/offers",
        favorites: "/favorites",
    },
};
